window.VegasFav = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');
		$self.attr('title', $self.data('title-active'));
		$self.attr('data-fav', 'del');
		$self.blur();

		let params = {
			_token: App.csrf,
			product_id: id
		};

		$.post('/account/favorites/add_product', params, function (data) {
			VegasFav.updateCounter(data);
			$product.addClass('in-fav');
			VegasFav.popup($product.data('title'), true);
		});
	},

	del: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');
		$self.attr('title', $self.data('title'));
		$self.attr('data-fav', 'add');
		$self.blur();

		let params = {
			_token: App.csrf,
			product_id: id
		};

		$.post('/account/favorites/del_product', params, function (data) {
			VegasFav.updateCounter(data);
			$product.removeClass('in-fav');
			
			let $fav_tbl = $('.vg-fav-tbl');
			if($fav_tbl.length) {
				$fav_tbl.find('tr[data-id='+ id +']').remove();
			}
		});
	},

	updateCounter: function (data) {
		if (typeof data.cnt !== false) {
			$('[data-counter=fav]').attr('data-cnt', data.cnt);
		}
	},
	
	popup: function (title, status = false) {
		let $modal = $('#modal-add-success');
		
		$modal.find('h4').text('Товар "'+ title + '" добавлен в избранное');
		
		$modal.modal('show');
		
		setTimeout(() => {
			$modal.modal('hide')
		}, 1500);
	}
};

let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-fav=add]', function () {
	VegasFav.add($(this));
	return false;
});
$document.on('click', '[data-fav=del]', function () {
	VegasFav.del($(this));
	return false;
});